
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/components/Login'
import appUser from '@/components/appUser/User'
import bizUser from '@/components/bizUser/BizUser'
import editUser from '@/components/appUser/editUser'
import editBizUser from '@/components/bizUser/EditBizUser'
import createUser from '@/components/appUser/createUser'
import cmsUser from '@/components/cmsUser/User'
import cmsCreateUser from '@/components/cmsUser/createUser'
import cmsEditUser from '@/components/cmsUser/editUser'
import serviceHotline from '@/components/content/serviceHotline/serviceHotline'
import createServiceHotline from '@/components/content/serviceHotline/createServiceHotline'
import editServiceHotline from '@/components/content/serviceHotline/editServiceHotline'
import officeLocation from '@/components/content/location/officeLocation'
import createOfficeLocation from '@/components/content/location/createOfficeLocation'
import editOfficeLocation from '@/components/content/location/editOfficeLocation'
import ourProducts from '@/components/content/product/ourProducts'
import createProject from '@/components/content/product/createProject'
import editProject from '@/components/content/product/editProject'
import notification from '@/components/notification/notification'
import createNotification from '@/components/notification/createNotification'
import editNotification from '@/components/notification/editNotification'
import editNotificationClone from '@/components/notification/editNotificationClone'
import campaign from '@/components/notification/campaign'
import editCampaign from '@/components/notification/editCampaign'
import editProjectClone from '@/components/content/product/editProjectClone'
import GenericContent from '../components/content/genericContent/genericContent.vue'
import GenericContentEdit from '../components/content/genericContent/genericContentEdit.vue'
import GenericContentCreate from '../components/content/genericContent/genericContentCreate.vue'
import portalIRUser from '../components/portalIRUser/portalIRUser.vue'
import AuditLog from '../components/auditLog/AuditLog.vue'

Vue.use(Router)
const router = new Router({
    //mode: 'history',
    routes: [
        // {path: '/', name: 'Home', component: Home,meta: {title: 'Waltons CMS - Home'}},
        { path: '/', name: 'Home', redirect: { name: 'appUser' } },
        { path: '/login', name: 'Login', component: Login, meta: { noRequiresAuth: true, title: 'Waltons CMS - Login' } },
        //app user
        { path: '/clientManagement', name: 'appUser', component: appUser, meta: { title: 'Waltons CMS - Client Management', keepAlive: true } },
        { path: '/editUser/:id', name: 'editUser', component: editUser, meta: { title: 'Waltons CMS - Edit Account' } },
        { path: '/createUser', name: 'createUser', component: createUser, meta: { title: 'Waltons CMS - Create Dummy Account' } },
        //business Partner
        { path: '/businessPartnerManagement', name: 'bizUser', component: bizUser, meta: { title: 'Waltons CMS - Business Partner Management', keepAlive: true } },
        { path: '/editPartner/:sfUserType/:id', name: 'editBizUser', component: editBizUser, meta: { title: 'Waltons CMS - Edit Business Partner Account' } },
        //cms user
        { path: '/adminUserManagement', name: 'cmsUser', component: cmsUser, meta: { title: 'Waltons CMS - Admin User Management', keepAlive: true } },
        { path: '/adminEditUser/:id', name: 'cmsEditUser', component: cmsEditUser, meta: { title: 'Waltons CMS - Edit Admin User' } },
        { path: '/adminCreateUser', name: 'cmsCreateUser', component: cmsCreateUser, meta: { title: 'Waltons CMS - Create Admin User' } },
        //service hotline
        { path: '/customerServiceHotline', name: 'serviceHotline', component: serviceHotline, meta: { title: 'Waltons CMS - Customer Service Hotline', keepAlive: false } },
        { path: '/createServiceHotline', name: 'createServiceHotline', component: createServiceHotline, meta: { title: 'Waltons CMS - Create Customer Service Hotline' } },
        { path: '/editServiceHotline/:id', name: 'editServiceHotline', component: editServiceHotline, meta: { title: 'Waltons CMS - Edit Customer Service Hotline' } },
        //office Location
        { path: '/officeLocations', name: 'officeLocation', component: officeLocation, meta: { title: 'Waltons CMS - Office Location', keepAlive: false } },
        { path: '/createOfficeLocation', name: 'createOfficeLocation', component: createOfficeLocation, meta: { title: 'Waltons CMS - Create Office Locations' } },
        { path: '/editOfficeLocation/:id', name: 'editOfficeLocation', component: editOfficeLocation, meta: { title: 'Waltons CMS - Edit Office Locations' } },
        //product
        { path: '/ourProducts', name: 'ourProducts', component: ourProducts, meta: { title: 'Waltons CMS - Our Products', keepAlive: true } },
        { path: '/createProject', name: 'createProject', component: createProject, meta: { title: 'Waltons CMS - Create Project' } },
        { path: '/editProject/:id', name: 'editProject', component: editProject, meta: { title: 'Waltons CMS - Edit Project' } },
        { path: '/editProjectClone/:id', name: 'editProject', component: editProjectClone, meta: { title: 'Waltons CMS - Edit Project' } },
        //push notification
        { path: '/pushNotification', name: 'notification', component: notification, meta: { title: 'Waltons CMS - Notification Management', keepAlive: true } },
        { path: '/createNotification', name: 'createNotification', component: createNotification, meta: { title: 'Waltons CMS - Create Notification' } },
        { path: '/editNotification/:id', name: 'editNotification', component: editNotification, meta: { title: 'Waltons CMS - Edit Notification' } },
        { path: '/editNotificationClone/:id', name: 'editNotification', component: editNotificationClone, meta: { title: 'Waltons CMS - Edit Notification' } },
        //campaign
        { path: '/campaignPopup', name: 'campaign', component: campaign, meta: { title: 'Waltons CMS - Campaign Popup Management' } },
        { path: '/editCampaign/:id', name: 'editCampaign', component: editCampaign, meta: { title: 'Waltons CMS - Edit Campaign Popup' } },
        //generic content
        { path: '/genericContents', name: 'genericContents', component: GenericContent, meta: { title: 'Waltons CMS - Generic Content Management' } },
        { path: '/createGenericContent', name: 'createGenericContent', component: GenericContentCreate, meta: { title: 'Waltons CMS - Create Generic Content' } },
        { path: '/editGenericContent/:id', name: 'editGenericContent', component: GenericContentEdit, meta: { title: 'Waltons CMS - Edit Generic Content' } },
        //portal ir users
        { path: '/irManagement', name: 'irManagement', component: portalIRUser, meta: { title: 'Waltons CMS - IR Users Management' } },
        //audit log analytics
        { path: '/Dashboard', name: 'auditLog', component: AuditLog, meta: { title: 'Waltons CMS - Dashboard' } },
    ]
})

router.beforeEach((to, from, next) => {
    let token = store.state.token;
    if (to.meta.title) {
        document.title = to.meta.title;
        next()
    }
    if (to.meta.noRequiresAuth) {
        next();
    } else {
        if (token) {
            if (Object.keys(from.query).length === 0) {
                next();
            } else {
                let redirect = from.query.redirect
                if (to.path === redirect) {
                    next()
                } else {
                    next({ path: redirect })
                }
            }
        } else {
            next({
                name: 'Login',
                //query: { redirect: to.fullPath }
            });
        }
    }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js